var EXPRESS = [
	{ code: "huitongkuaidi", company: "百世汇通" },
	{ code: "debangwuliu", company: "德邦物流" },
	{ code: "ems", company: "EMS" },
	{ code: "shentong", company: "申通快递" },
	{ code: "shunfeng", company: "顺丰速运" },
	{ code: "tiantian", company: "天天快递" },
	{ code: "yuantong", company: "圆通速递" },
	{ code: "yunda", company: "韵达快运" },
	{ code: "youzhengguonei", company: "邮政包裹" },
	{ code: "zhongtong", company: "中通速递" },
	{ code: "zhaijisong", company: "宅急送" }
];
export default EXPRESS;
